<template>
  <div>
    <Head title="Ventas" />

    <!-- 1. Header & Acciones Principales -->
    <OrderHeader 
      title="Ventas"
      :total-count="stats?.total_orders || orders?.total"
      :user="user"
      create-url="/orders/create"
      pos-url="/pos"
      daily-report-url="/ordersDaily"
      devolutions-url="/devolutions"
      :has-export="true"
      :has-import="true"
      export-excel-url="/orders/export/excel"
      export-pdf-url="/orders/export/pdf"
      @open-import="isImportModalOpen = true"
    />

    <!-- 2. Sección de Estadísticas / KPIs -->
    <OrderStats :stats="stats" />

    <!-- 3. Barra de Búsqueda y Filtros Rápidos -->
    <OrderFilters 
      v-model:search="form.search"
      v-model:state="form.state"
      :states="states"
    />

    <!-- 4. Tabla y Listado Principal -->
    <OrderTable 
      :orders="orders"
      :states="states"
    />

    <!-- 5. Modal de Importación Masiva -->
    <OrderImportModal 
      v-if="isImportModalOpen"
      :csrf="csrf"
      @close="isImportModalOpen = false"
    />
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import OrderHeader from './Partials/OrderHeader.vue'
import OrderStats from './Partials/OrderStats.vue'
import OrderFilters from './Partials/OrderFilters.vue'
import OrderTable from './Partials/OrderTable.vue'
import OrderImportModal from './Partials/OrderImportModal.vue'

export default {
  name: 'OrdersIndex',

  components: {
    Head,
    OrderHeader,
    OrderStats,
    OrderFilters,
    OrderTable,
    OrderImportModal,
  },

  layout: Layout,

  props: {
    orders: {
      type: Object,
      required: true,
    },
    stats: {
      type: Object,
      default: () => null,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    csrf: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isImportModalOpen: false,
      form: {
        search: this.filters?.search || '',
        state: this.filters?.state || null,
      },
      states: [
        { key: 'request', name: 'Pendientes por pago' },
        { key: 'dispatch', name: 'Despachadas' },
        { key: 'delivery', name: 'En espera / Entregadas' },
        { key: 'pay', name: 'Pagadas' },
        { key: 'finish', name: 'Finalizadas' },
        { key: 'estimate', name: 'Presupuestos' },
        { key: 'cancel', name: 'Anuladas' },
        { key: 'payRevition', name: 'Pago en revisión' },
      ],
    }
  },

  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/orders', pickBy(this.form), {
          preserveState: true,
          replace: true,
        })
      }, 300),
    },
  },
}
</script>
